module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-scroll-comp"
  }, [_c('div', {
    staticClass: "inner-wrapper",
    style: ({
      width: _vm.itemWidth * _vm.totalItems + 'px',
      transform: 'translateX(' + (+_vm.xPosition - +_vm.itemWidth / 2) + 'px)'
    }),
    on: {
      "mousewheel": function($event) {
        _vm.convertScrollToVertical($event)
      },
      "touchstart": function($event) {
        _vm.onTouchStart($event)
      },
      "touchmove": function($event) {
        _vm.onTouchMove($event)
      }
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-434b25e7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HScrollComp.vue
// module id = 273
// module chunks = 1